<template>
  <v-card :loading="loading" outlined class="stock-card">
    <v-card-text class="pa-4">
      <div class="stock-header">
        <div>
          <div class="section-title">Stock</div>
          <div class="section-subtitle">Product balance by category</div>
        </div>

        <v-btn small rounded outlined :loading="loading" @click="loadData">
          <v-icon left small>mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </div>

      <v-skeleton-loader
        v-if="loading"
        type="card"
        class="mt-4"
      />

      <div v-else>
        <div v-if="hasData" :id="chartId" class="stock-chart mt-4"></div>

        <div v-else class="empty-state">
          No stock data found.
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import categoryService from "@/modules/Product/Category/service";
import Highcharts from "highcharts";

export default {
  name: "category-stock-chart",

  data() {
    return {
      loading: false,
      hasData: false,
      chart: null,
      chartId: `stock-line-${Math.random().toString(36).substr(2, 9)}`,
    };
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        const response = await categoryService.getAll();
        const rows = response.data || [];

        const chartData = rows
          .map((row) => {
            return [row.name || "Unknown", Number(row.productBalance || 0)];
          })
          .sort((a, b) => b[1] - a[1]);

        this.hasData = chartData.length > 0;

        this.loading = false;

        this.$nextTick(() => {
          if (this.hasData) {
            this.renderChart(chartData);
          }
        });
      } catch (error) {
        console.error("category stock chart failed", error);
        this.hasData = false;
        this.loading = false;
      }
    },

    renderChart(chartData) {
      const el = document.getElementById(this.chartId);

      if (!el) {
        return;
      }

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      this.chart = Highcharts.chart(this.chartId, {
        credits: {
          enabled: false,
        },

        chart: {
          type: "column",
          height: 360,
          backgroundColor: "transparent",
          spacingTop: 10,
          spacingRight: 10,
          spacingBottom: 10,
          spacingLeft: 0,
        },

        title: {
          text: null,
        },

        xAxis: {
          type: "category",
          lineColor: "#e2e8f0",
          tickColor: "#e2e8f0",
          labels: {
            rotation: -35,
            style: {
              color: "#64748b",
              fontSize: "12px",
            },
          },
        },

        yAxis: {
          min: 0,
          gridLineColor: "#e2e8f0",
          title: {
            text: "Product Count",
            style: {
              color: "#64748b",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontSize: "12px",
            },
          },
        },

        legend: {
          enabled: false,
        },

        tooltip: {
          useHTML: true,
          borderRadius: 12,
          pointFormat: "<b>{point.y:.0f}</b> products",
        },

        plotOptions: {
          column: {
            borderRadius: 6,
            pointPadding: 0.12,
            groupPadding: 0.08,
          },
          series: {
            animation: {
              duration: 700,
            },
          },
        },

        series: [
          {
            name: "Stock",
            color: "#2563eb",
            data: chartData,
            dataLabels: {
              enabled: true,
              format: "{point.y:.0f}",
              style: {
                color: "#0f172a",
                fontSize: "12px",
                fontWeight: "700",
                textOutline: "none",
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.stock-card {
  border-radius: 20px;
  background: #ffffff;
}

.stock-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.section-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.section-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.stock-chart {
  min-height: 360px;
}

.empty-state {
  text-align: center;
  color: #64748b;
  font-size: 13px;
  padding: 40px 0 20px;
}
</style>